import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-price-index-menu',
  templateUrl: './price-index-menu.component.html',
  styleUrls: ['./price-index-menu.component.css']
})
export class PriceIndexMenuComponent implements OnInit {
    priceIndexKeyno;

    public menu?: Menu;

    public grid?: GridOptions;

    public creating = false;

    public priceIndexNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'priceindex', gotoParms: () => this.menu!.priceindex_keyno ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.priceIndexKeyno = this.stateService.getStateParams()['priceindex_keyno'];
    }

    private async loadMenu() {
        if (!!this.priceIndexKeyno) {
            this.menu = (await this.datatask.Post(3223, { priceindex_keyno: this.priceIndexKeyno }))[0];
        }
    }

    private loadGrid() {
        this.grid = new Grid()
            .setRememberId('w_priceindexdata_grid')
            .setLoadDataFunction({
                method: 3226,
                parameters: { priceindex_keyno: this.menu?.priceindex_keyno }
            })
            .setKendoConfig({ height: '100%' })
            .setToolbar({ wrapping: true });

        this.grid?.gridfunc?.read();
    }

    public async createChanges() {
        if (!!this.menu) {
            try {
                this.creating = true;

                const response = (await this.datatask.Post(3227, this.menu))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.loadGrid();
                }
            } finally {
                this.creating = false;
            }
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    priceindex_keyno: string;
    priceindex_name: string;
    reg_datetime: string;
    reg_by_portal_user_name: string;
    index_intervaltype: string;
    create_fom_year: number;
    create_tom_year: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('priceIndexMenu', {
//        templateUrl: 'views/components/views/priceIndexMenu/priceIndexMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'priceIndexMenuService', 'ttGridFactory', function ($stateParams, stateService, modalService, translateService, priceIndexMenuService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let priceIndexKeyno = $stateParams.priceindex_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                priceIndexNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('priceindex', { priceindex_keyno: vm.model.menu.priceindex_keyno }) }
//                ],
//                menu: {},
//                gridReady: false,
//                creating: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_priceindexdata_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadMenu() {
//                vm.model.menu = (await priceIndexMenuService.getMenu({ priceindex_keyno: priceIndexKeyno }))[0];

//                loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region GRID PROCEDURE FUNCTION CALL

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3226,
//                    parameters: { priceindex_keyno: vm.model.menu.priceindex_keyno }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.createChanges = function () {
//                vm.model.creating = true;

//                priceIndexMenuService.createObj(vm.model.menu).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.creating = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.creating = false;

//                        loadGrid();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
